import moment from "moment";
import { useState, useRef } from "react";
import { Dropdown } from "react-bootstrap";
import AdapterDatetime from "@mui/lab/AdapterMoment";
import { LocalizationProvider } from "@mui/lab";

import { ReactComponent as CalendarOutline } from "assets/svg/calendar-outline.svg";

import { MonthTimeRange } from "types/Reports";
import { DATE_TIME_FORMATS } from "constant";
import { CustomMonthPicker } from "../dashboard/ChartByTime";
import CustomDropdownToggle from "../common/CustomDropdownToggle";

type ReportMonthPickerProps = {
    timeRange: MonthTimeRange;
    handleTimeRangeChange: (value: MonthTimeRange) => void;
};

export default function ReportMonthPicker({
    timeRange,
    handleTimeRangeChange,
}: Readonly<ReportMonthPickerProps>) {
    const [open, setOpen] = useState<boolean>(false);
    const toggleRef = useRef<HTMLButtonElement | null>(null);
    const pickerId = open ? "report-month-calendar" : undefined;

    const onOpen = () => {
        setOpen(!open);
    };

    const onChange = (value: moment.Moment) => {
        const startDate = moment.unix(value.startOf('month').unix());
        const endDate = moment.unix(value.endOf('month').unix());
        handleTimeRangeChange({ startDate, endDate });
    };

    return (
        <div className="report-month-picker">
            <p className="report-month-picker-title">Report Month</p>
            <Dropdown className="text-right report-month-picker-dropdown">
                <LocalizationProvider dateAdapter={AdapterDatetime}>
                    <CustomMonthPicker
                        open={open}
                        anchorElement={toggleRef.current}
                        id={pickerId}
                        onChange={onChange}
                        onClose={() => setOpen(false)}
                        disableFuture={true}
                    />
                </LocalizationProvider>
                <CustomDropdownToggle
                    className='report-month-picker-toggle'
                    onClick={onOpen}
                    ref={toggleRef}
                    aria-describedby={pickerId}
                    data-testid="report-month-picker-toggle"
                >
                    <CalendarOutline width="16px" height="16px" />
                    <div className="d-flex flex-row justify-content-between">
                        <span>{`${timeRange.endDate.format(DATE_TIME_FORMATS.MONTH_ONLY)}`}</span>
                        <i className="material-icons down ml-2">
                            keyboard_arrow_down
                        </i>
                    </div>
                </CustomDropdownToggle>
            </Dropdown>
        </div>
    );
}
